// extracted by mini-css-extract-plugin
module.exports = {"live__list":"style_live__list__Csgnj","live__list-wrapper":"style_live__list-wrapper___35lg"};